import React from "react";

import { AlertTriangle, ThumbsDown, ThumbsUp } from "lucide-react";

import { Alert, AlertDescription, AlertTitle } from "~/components/ui/alert";
import { Button } from "~/components/ui/button";

interface ApproveRejectActionsProps {
  canApproveOrReject: boolean;
  isPending: boolean;
  onApprove: () => void;
  onReject: () => void;
  clientRiskChecked?: boolean;
  approveText?: string;
  rejectText?: string;
}

export const ApproveRejectActions: React.FC<ApproveRejectActionsProps> = ({
  canApproveOrReject,
  isPending,
  onApprove,
  onReject,
  clientRiskChecked = true,
  approveText = "Aprobar",
  rejectText = "Rechazar",
}) => {
  // If user has no permission or order is not pending, show nothing
  if (!canApproveOrReject || !isPending) {
    return null;
  }

  // If client hasn't passed risk check, show warning instead of buttons
  if (!clientRiskChecked) {
    return (
      <Alert variant="default" className="mt-4 border-gray-200 bg-gray-100">
        <AlertTriangle className="h-4 w-4 text-amber-500" />
        <AlertTitle>Revisión de riesgo pendiente</AlertTitle>
        <AlertDescription>
          Este cliente necesita pasar la aprobación de riesgo primero, revisa de
          nuevo en 24 horas.
        </AlertDescription>
      </Alert>
    );
  }

  // Show approval/rejection buttons
  return (
    <div className="mt-4 flex justify-end gap-3">
      <Button
        onClick={onReject}
        variant="outline"
        className="flex items-center gap-2 border-red-200 text-red-600 hover:bg-red-50"
        size="sm"
      >
        <ThumbsDown className="h-4 w-4" />
        {rejectText}
      </Button>
      <Button
        onClick={onApprove}
        className="flex items-center gap-2 bg-green-600 hover:bg-green-700"
        size="sm"
      >
        <ThumbsUp className="h-4 w-4" />
        {approveText}
      </Button>
    </div>
  );
};
